import { Dispatch } from 'react'
import { User } from '@global/types'

export interface CurrentCommentDetails {
  commenter: User
  cvId: string
  fieldId: number | string
  rowIdx: number
}

export type Comments = Record<
  string,
  Record<
    number,
    {
      commenter: User
      message: string
    }
  >
>

export interface RemoveCommentArgs {
  cvId: string
  fieldId: number | string
  rowIdx: number
}

export interface ContextState {
  comments: Comments
  currentCommentDetails: CurrentCommentDetails | null
  commentDialogOpen: boolean
  rowsWithComments: any[]
}

export interface ContextValues extends ContextState {
  rows: any[]
  columns: any[]
  commentCount: number
  addComment: ({
    currentCommentDetails,
    message,
  }: {
    currentCommentDetails: CurrentCommentDetails
    message: string
  }) => void
  removeComment: ({ cvId, fieldId, rowIdx }: RemoveCommentArgs) => void
  dispatch: Dispatch<any>
}

export enum ActionType {
  setCommentDialogOpen = 'setCommentDialogOpen',
  setCurrentCommentDetails = 'setCurrentCommentDetails',
  setComments = 'setComments',
  setRowsWithComments = 'setRowsWithComments',
  clearComments = 'clearComments',
}

export type Action =
  | { type: ActionType.setCommentDialogOpen; payload: boolean }
  | { type: ActionType.setCurrentCommentDetails; payload: CurrentCommentDetails | null }
  | { type: ActionType.setComments; payload: Comments }
  | { type: ActionType.setRowsWithComments; payload: any[] }
  | { type: ActionType.clearComments }
